import React from 'react';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {gt} from 'app/utils/i18n';

type Props = {
  hashid: string;
  name?: string;
  icon?: boolean;
  className?: string;
  html_url?: string;
};

export const FolderLink = ({
  html_url,
  hashid,
  name = gt('view folder'),
  className = '',
  icon = false,
}: Props) => {
  if (html_url == null) {
    html_url = '/documents/?folder=' + hashid;
  }
  return (
    <FullHTMLLink html_url={html_url} className={className}>
      {icon ? <i className="fa fa-folder mr-1" /> : null} {name}
    </FullHTMLLink>
  );
};
